import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/PrintPutAwayForm';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const PrintPutAwayForm = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h6 style={{fontSize: 18, marginTop: 6, marginBottom: 12}} className="page-title-1">PUTAWAY - Assign Task</h6>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

PrintPutAwayForm.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(PrintPutAwayForm);
